/**
 * El aviso de que una mision NO se cerro (SEC quinta puerta, nexo-api PR 435): flota sobre la pagina y sobrevive al
 * repintado de la vista. Lo usan los tres caminos para cerrar una mision (detalle, lista de misiones y lista de
 * tareas) con la frase de application/misiones/cierreDeMision.js, para que digan lo mismo. Texto con textContent.
 *
 * @module presentation/shared/avisoDeCierre
 */
export function avisarCierre(texto, motivo = 'ERROR') {
  const aviso = document.createElement('div');
  aviso.className = 'reward-toast';
  aviso.dataset.cierreRechazado = motivo;
  aviso.style.borderColor = '#d29922';
  aviso.textContent = texto;
  document.body.appendChild(aviso);
  requestAnimationFrame(() => aviso.classList.add('visible'));
  setTimeout(() => { aviso.classList.remove('visible'); setTimeout(() => aviso.remove(), 400); }, 6000);
}
